// removed by extract-text-webpack-plugin
module.exports = {"root":"cms__ToolbarComponentsMenu__root","menuItem":"cms__ToolbarComponentsMenu__menuItem"};


//////////////////
// WEBPACK FOOTER
// ./components/Widgets/MarkdownControlElements/Toolbar/ToolbarComponentsMenu.css
// module id = 587
// module chunks = 0